module.exports = __webpack_public_path__ + "media/reskin-images/img--pick-path-1-5ae1c09f.png";